module.exports = __webpack_public_path__ + "static/media/website_creation.79bd29b4.svg";